export const SPRITE_EXTERNAL_LINK_MESSAGE_TYPE = 'sprite-external-link';

export const SPRITE_BASE_STYLES = `
body { margin-inline: auto; }
body > * { margin-inline: auto; }
`;

/**
 * Click-forwarding script for sandboxed sprite iframes. Pass as `headScript` to
 * `@littlebird/canvas`'s `buildSandboxedSrcDoc` / `buildCanvasSrcDoc` so external
 * `https://` clicks postMessage to the host and in-document `#` fragments scroll.
 */
export const SPRITE_EXTERNAL_LINK_SCRIPT = `
document.addEventListener('click', function (event) {
  var target = event.target instanceof Element ? event.target : null;
  var anchor = target && target.closest('a[href]');
  if (!anchor) return;
  event.preventDefault();
  var href = (anchor.getAttribute('href') || '').trim();
  if (/^https?:\\/\\//i.test(href)) {
    window.parent.postMessage({ type: '${SPRITE_EXTERNAL_LINK_MESSAGE_TYPE}', url: href }, '*');
    return;
  }
  if (href.charAt(0) !== '#') return;
  var fragment = href.slice(1);
  try { fragment = decodeURIComponent(fragment); } catch (e) {}
  var destination = document.getElementById(fragment) || document.getElementsByName(fragment)[0];
  if (destination) destination.scrollIntoView();
}, true);
`;
